import { makeVar } from '@apollo/client'

export const darkMode = makeVar<boolean>(
  localStorage.theme === 'dark' ? true : false
)
